import translations from './translations'

translations.add('en', {
    headerMessage: 'Have you already paid using your banking app?',
    no: 'No',
    yes: 'Yes'
})
